module.exports = __webpack_public_path__ + "img/table-icon-cliente.3fa51834.png";